import InputSelect from 'components/inputs/inputSelect';
import { InputContainer, Label, Textarea } from 'components/modal/styles';
import Button from 'components/button';
import { useState } from 'react';
import styled from 'styled-components';

const { Container, Header, Title, Subtitle, PurpleHighlight, Form } = {
  Container: styled.div`
    display: flex;
    gap: 30px;
    padding: 40px;
    background-color: white;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.default.colors.dataVisualization.gray.dusty};
    border-radius: 8px;
    margin-top: 30px;
  `,
  Header: styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 40%;
  `,
  Title: styled.h3`
    margin: 0;

    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    color: ${({ theme }) => theme.default.colors.palette.Primary_INEBlack};
  `,
  Subtitle: styled.p`
    margin: 0;

    font-size: 18px;
    font-style: normal;
    font-weight: 450;
    line-height: 24px;
    color: ${({ theme }) => theme.default.colors.palette.Primary_INEBlack};
  `,
  PurpleHighlight: styled.h4`
    margin: 0;

    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;

    background: var(--secondary-promo-purple-gradient);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  `,
  Form: styled.form`
    display: flex;
    flex-direction: column;
    gap: 30px;
    flex: 1;
  `,
};

const PredefinedReportsTab: React.FC = () => (
  <iframe
    src="https://docs.google.com/forms/d/e/1FAIpQLSflsjP2aGUrRWQKN8_Diu7f3aJZpjeEl8oyucz6Zw_zmp4L7w/viewform?embedded=true"
    width="100%"
    height="1200"
  >
    Loading…
  </iframe>
);

const FigmaFormDesign: React.FC = () => {
  const [selectedReport, setSelectedReport] = useState('');
  const [metricsTextArea, setMetricsTextArea] = useState('');
  const [selectedRadio, setSelectedRadio] = useState('positive');

  const sendFeedback = () => ({});
  return (
    <Container>
      <Header>
        <PurpleHighlight>PREDEFINED REPORTS COMING SOON!</PurpleHighlight>
        <Title>We’re Releasing New Options for Automating Reports!</Title>
        <Subtitle>
          We’re building ready-to-use report templates to help you get the insights you need—fast.
          Tell us what matters most to you, so we can make these updates as valuable as possible. 🚀
        </Subtitle>
      </Header>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          sendFeedback();
        }}
      >
        <InputContainer>
          <Label>Which reports do you use the most?</Label>
          <InputSelect
            value={selectedReport}
            options={[]}
            placeHolder="Select most usage reports"
            onChange={(e) => setSelectedReport('')}
          />
        </InputContainer>

        <InputContainer>
          <Label>Delivery Frequency</Label>
          <Textarea
            value={metricsTextArea}
            placeholder="e.g., User activity trends, Course completion breakdown, Team performance overview"
            onChange={(e) => setMetricsTextArea(e.currentTarget.value)}
          />
        </InputContainer>

        <InputContainer>
          <Label>
            Would you be interested in sharing more feedback about your reporting needs?
          </Label>
          <div className="form-check d-flex">
            <input
              className="form-check-input"
              type="radio"
              id="positiveRadioBtn"
              value={'asdasd123'}
              onChange={() => setSelectedRadio('positive')}
              defaultChecked
              checked={selectedRadio === 'positive'}
            />
            <Label className="ms-3 fw-bold" htmlFor="positiveRadioBtn">
              Yes, I’d love to help shape reporting features
            </Label>
            <input
              className="form-check-input ms-8"
              type="radio"
              id="negativeRadioBtn"
              value={'asdasd123'}
              onChange={() => setSelectedRadio('negative')}
              checked={selectedRadio === 'negative'}
            />
            <Label className="ms-3 fw-bold" htmlFor="negativeRadioBtn">
              No, not at this time
            </Label>
          </div>
        </InputContainer>
        <div className="d-flex justify-content-end">
          <Button size="small" onClick={sendFeedback}>
            Send feedback
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default PredefinedReportsTab;
